'use strict'
import { axios, getErrorMessage } from '../helpers/axioshelper'

export default {
  exportTestData(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/testdata/`, data, {responseType: 'blob'})
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'tests.xlsx')
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  }
}
